export function getChatArray(chat, date, is_admin){
  return(
    {
      chatArray:
      [{
        chats: [chat],
        is_admin: is_admin
      }],
      date: date
    }
  );
}

export function getChats(chat, is_admin){
  return(
    {
      chats: [chat],
      is_admin: is_admin
    }
  )
}

export function getObjects( last_chat, chatLog ){
  return(
    {
      last_chat: {...last_chat},
      chatLog: [...chatLog],
      last_date: new Date(last_chat.date).toDateString(),
      curr_date: new Date()
    }
  )
}


/*
  Need to explain or make this algorithm simpler
*/

export function sortChat(chatLog){

  let chatArray = [];
  let ownerArray = [];
  let date = chatLog[0].date;
  let is_admin = chatLog[chatLog.length-1].coach_id?true:false;
  let sortedArray = [];

  [...chatLog].reverse().map((chat,i)=>{
    if(is_admin !== (chat.coach_id?true:false) || chat.date.slice(0,10) !== date.slice(0,10)){
      chatArray.push({is_admin:is_admin, chats:ownerArray});
      ownerArray = [];
      is_admin = chat.coach_id?true:false;
    }
    if(chat.date.slice(0,10) !== date.slice(0,10)){
      let jsonObj = {date: date, chatArray: chatArray};
      sortedArray.push(jsonObj);
      is_admin = chat.coach_id?true:false;
      date = chat.date;
      chatArray = [];
    }
    ownerArray.push(chat)
    return ownerArray;
  })

  chatArray.push({is_admin:is_admin, chats:ownerArray});
  sortedArray.push({date: date, chatArray: chatArray});

  return ({log:sortedArray, last_chat:{date:date, is_admin}});
}



// WEBPACK FOOTER //
// ./src/util/chatUtils.js